import React from 'react';
import PropTypes from 'prop-types';
import { Avatar, Cushion, FlexContainer, Rectangle, Typography, Shadow } from '@pitchero/react-ui';
import Icon from '../../icon';
import ClubLink from '../../club-link';

const Profile = ({ teamId, avatar, name, position, profile_type: profileType, id, seasonId }) => (
  <ClubLink
    route="team.squad.profile"
    params={{ teamId, profileType, _profile: name, profileId: id, seasonId }}
  >
    <a>
      <Rectangle fill="white" radius="rounded">
        <Shadow>
          <Cushion all="medium">
            <FlexContainer flexDirection="row" justifyContent="space-between" alignItems="center">
              <Avatar image={avatar} includeRetina alt={name} size={48} />
              <Cushion horizontal="medium" style={{ flex: 1 }}>
                <Typography
                  preset="subtitle--small"
                  component="div"
                  color="black"
                  transform="capitalize"
                >
                  {String(name).toLowerCase()}
                </Typography>
                {position && (
                  <Typography preset="description" color="dustygrey" transform="capitalize">
                    {position}
                  </Typography>
                )}
              </Cushion>
              <Icon name="arrow-right" color="alto" size={14} />
            </FlexContainer>
          </Cushion>
        </Shadow>
      </Rectangle>
    </a>
  </ClubLink>
);

Profile.defaultProps = {
  position: null,
  seasonId: null,
};

Profile.propTypes = {
  teamId: PropTypes.number.isRequired,
  id: PropTypes.number.isRequired,
  profile_type: PropTypes.string.isRequired,
  avatar: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  position: PropTypes.string,
  seasonId: PropTypes.number,
};

export default Profile;
